import API from '.';

export default class StoreBrand {
  /**
   * The storeBrand dimension table for UDM
   * @param {number} storeBrandId Id of the storeBrand.
   * @param {string} storeBrandName Name of the storeBrand.
   * @param {string} storeBrandDesc Description of the storeBrand.
   */
  constructor({ storeBrandId, storeBrandName, storeBrandDesc }) {
    this.storeBrandId = storeBrandId;
    this.storeBrandName = storeBrandName;
    this.storeBrandDesc = storeBrandDesc;
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get('/storeBrand');
    return data.map((d) => new StoreBrand(d));
  }

  static async get(id) {
    const api = await API();
    const { data } = await api.get(`storeBrand/${id}`);
    return new StoreBrand(data);
  }

  //TESTED. Below Create method works!
  // static async create(data) {
  //   const api = await API();
  //   console.log(data);
  //   const { res } = await api.post('storeBrand', data);
  //   return res;
  // }

  // static async update (id, data) {
  //   const api = await API();
  //   const { res } = await api.put(`/storeBrand`, data);
  //   return res;
  // }
}
